<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    centered
    no-close-on-esc
    no-close-on-backdrop
    size="lg"
  >
    <div class="flex flex-col items-center justify-center gap-[1.75rem] p-1">
      <div class="text-center text-black text-xl font-semibold">
        Cara Melihat ID Portfolio Meta
      </div>
      <p class="text-[#626262]">
        Ikuti langkah-langkah berikut untuk menemukan ID Business Manager Portfolio
      </p>
      <img
        class="d-block rounded-2xl border w-full h-[250px] object-cover object-top"
        lazy
        src="https://storage.googleapis.com/komerce/Komads/how-to-find-business-manager-id-with-pointer.png"
        alt="image-business-manager-id"
      >
      <div class="space-y-5 w-full">
        <p><span class="font-semibold">
          Langkah 1:</span> Login ke <a
          href="https://business.facebook.com"
          target="_blank"
        ><span class="step-link">https://business.facebook.com</span></a> dan lengkapi verifikasi 2FA.</p>
        <p><span class="font-semibold">Langkah 2:</span> Masuk ke menu Info Portofolio Bisnis di panel navigasi kiri.</p>
        <p><span class="font-semibold">Langkah 3:</span> Salin ID Business Manager yang tertera di bawah nama portofolio.</p>
      </div>
      <b-button
        variant="primary"
        class="ms-auto w-1/3"
        @click="$bvModal.hide(id)"
      >
        Oke, Mengerti
      </b-button>
    </div>
  </b-modal>
</template>

<style scoped>
p {
    margin: 0;
}

.step-link {
  color: #08A0F7 !important;
  font-weight: 500 !important;
  text-decoration-thickness: 2px !important;
}

.step-link:hover {
  text-decoration: underline;
}
</style>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'modal-find-business-manager-id',
    },
  },
}
</script>
